import React, { useEffect, useState } from "react"
import { useSearchParams } from 'react-router-dom';
import { useCedulasContext } from "Context/CedulasPageContext"
import PersonsFinder from "../components/organisms/PersonsFinder/PersonsFinder"
import Alert from "../components/moleculas/Alert/Alert"
import GoToComponent from "../components/moleculas/GoToComponent/GoToComponent"
import CitizenMilBoxForm from "../components/moleculas/CitizenMilBoxForm/CitizenMilBoxForm"
import styles from "./CedulaStyles";
import { Box, Typography, Container } from "@mui/material";

const Cedula = () => {
    const { handleSearchedQR, handleSearchedShare, searchPeopleCedulas } = useCedulasContext();
    
    const [searchParams] = useSearchParams();
    const [showCitizenMilBoxForm, setShowCitizenMilBoxForm] = useState(false);
    const [personName, setPersonName] = useState("");
    const [defaultSex, setDefaultSex]  = useState("");
    const [personId, setPersonId] = useState("");
    const [filterDefaultValues, setFilterDefaultValues] = useState({});
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertType, setAlertType] = useState('ok');
    const [alertTitle, setAlertTitle] = useState('');
    const [alertDescription, setAlertDescription] = useState('');

    const handleFormOnSubmit = (success) => {
        setAlertType(success ? 'ok' : 'error')
        setAlertTitle(success ? 'Tu mensaje se envió de forma exitosa.' : 'No fue posible enviar tu mensaje.');
        setAlertDescription(success ? 'Gracias por compartir información para la búsqueda de personas.' : 'Por favor inténtalo nuevamente.');
        setAlertOpen(true);
    };

    useEffect(() => {
        handleSearchedQR(searchParams.get('qr'));
        handleSearchedShare(searchParams.get('share'));

        if (searchParams.get('id_cedula_busqueda')) { 
            searchPeopleCedulas(1, searchParams.get('id_cedula_busqueda'));
            return
        }

        const params = {}
        searchParams.forEach((value, key) => {
            params[key] = value;
        });

        setFilterDefaultValues(params);
        if (Object.keys(params).length > 0) {
            searchPeopleCedulas(params);
        }

        const formDefaultValuesAux = {};
        if (searchParams.nombre) {
            formDefaultValuesAux.name = searchParams.nombre;
        }
        // eslint-disable-next-line
    }, [searchParams]);

    const onPressReport = (name, id_cedula_busqueda, sexo) => {
        setPersonName(name);
        setPersonId(id_cedula_busqueda);
        setDefaultSex(sexo)
        setShowCitizenMilBoxForm(true);
    };

    const closeCitizenMilBoxForm = () => {
        setShowCitizenMilBoxForm(false);
    };
    
    return (
        <Box sx={{ overflowX: "hidden" }}>
            <Alert 
                type={alertType}
                open={alertOpen}
                title={alertTitle}
                description={alertDescription}
                onClose={() => setAlertOpen(false)}
            />
            {showCitizenMilBoxForm && (
                <Box 
                    sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: 'rgba(69, 69, 69, 0.77)',
                        backdropFilter: 'blur(8px)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000
                    }}
                    onClick={() => setShowCitizenMilBoxForm(false)}
                >
                    <CitizenMilBoxForm
                        defaultName={personName}
                        id_cedula_busqueda={personId}
                        defaultSex={defaultSex}
                        onFormDidSubmit={(success) => {
                            handleFormOnSubmit(success);
                            setShowCitizenMilBoxForm(false);
                        }}
                        onClose={closeCitizenMilBoxForm}
                    />
                </Box>
            )} 
            
            <Box backgroundColor="#1C5866">
                <Container maxWidth="xl" sx={{ px: 0, pt: 16,  pb: {xs: 5, sm: 20}}}>
                    <Box sx={styles.titleBox}>
                        <Typography sx={styles.titleText}>Cédulas de Búsqueda de Personas Desaparecidas</Typography>
                        <Typography sx={{ color: '#FFF', fontSize: '1.2rem', mt: 2, mb: { xs: 8, sm: 4 }, textAlign: 'center' }}>
                            Aquí puedes consultar las cédulas emitidas por la Comisión de Búsqueda de Personas del Estado de Jalisco. Puedes utilizar los filtros para encontrar la cédula de una persona y el botón “Reportar” si tienes información que pueda ayudar a localizarla.
                        </Typography>
                    </Box>
                </Container>
            </Box>
            <Box>
                <Container maxWidth="xl" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', mb: 5}}>
                    <PersonsFinder 
                        defaultValues={filterDefaultValues}
                        onPressReport={onPressReport}
                    /> 
                    <GoToComponent title={"¿Qué hago si alguna persona de mi familia o con quien tengo una relación cercana está desaparecida? Acude a:"}/>
                </Container>
            </Box>
        </Box>
    )
}

export default Cedula
